<template>
  <div id="attendance-img-wrapper">
    <div class="attendance-wrapper">
      <div v-for="i in 7" class="attendance_wrap" :class="{ seven: i === 7 }" :key="i">
        <div v-if="i === 7" class="title">7day</div>
        <img :src="attendanceImgUrl(i)" />
      </div>
    </div>

    <div class="apt-img" v-if="isMobile"></div>
  </div>
</template>

<script>
const lastDayImg = (bool) => (bool ? 'last' : 'default_last');

function atdcImgNum(num) {
  switch (num) {
    case 2:
    case 5:
      return '2';
    case 3:
    case 6:
      return '3';

    default:
      return '1';
  }
}

export default {
  name: 'EventAttendanceBoard',
  props: {
    cnt_attendance: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    isDouble() {
      return !!this.$store.state.attendanceEvent?.isDouble;
    },
  },
  methods: {
    attendanceImgUrl(day) {
      const baseImgText = `${this.$s3}/img/common/attendance/header_menu/${this.isDouble ? 'double_' : ''}event_`;
      const isAttendance = day <= this.cnt_attendance;
      const attendaneImgUrl = isAttendance ? `${atdcImgNum(day)}` : 'default';

      if (+day === 7) return `${baseImgText}${lastDayImg(day <= this.cnt_attendance)}.webp?${this.$ver}`;
      return `${baseImgText}${attendaneImgUrl}.webp?${this.$ver}`;
    },
  },
};
</script>

<style lang="scss" scoped>
#attendance-img-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  background: #ffffff;
  width: 100%;
  max-width: 419px;
  margin: 0 auto;
  aspect-ratio: 42 / 16.8;

  @include tablet {
    grid-template-columns: 1fr auto;
  }

  .apt-img {
    min-width: 72px;
    width: 100%;
    // aspect-ratio: 15.6 / 28.8;
    background: top / cover no-repeat url($s3-url + '/img/common/mypage/attendance.webp?' + $version);
  }

  .attendance-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr) auto;
    border: 0.5px solid #ededed;
    border-left: 0;

    .attendance_wrap {
      position: relative;
      border: 0.5px solid #ededed;
      padding: 6px;

      &.seven {
        grid-column: 1 / 4;
      }

      img {
        width: 100%;
      }

      .title {
        font-size: 10px;
        color: #fff;
        background: #000000;
        border-radius: 10px;
        position: absolute;
        padding: 1px 6px;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>
